module.exports = __webpack_public_path__ + "files/0ea8a9fecc36dfce3aed031120652b87.png";